// extracted by mini-css-extract-plugin
module.exports = {"loader":"timer_loader__1AYYI","loaderPost":"timer_loaderPost__3agBU","outerLoader":"timer_outerLoader__35ztF"};